// @core/api/endpoints/notifications/set_contact_primary.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetContactPrimaryRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Set contact as primary
 * Designates a contact as the primary contact of its type for the owner entity. The previous primary contact of the same type will be demoted.
 */
export async function SetContactPrimary(
  contact_id: string,
  data: SetContactPrimaryRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/contacts/:contact_id/primary`;
  requestPath = requestPath.replace(':contact_id', encodeURIComponent(contact_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
